( function () {
	'use strict';

	function initSubnav( root ) {
		var toggles = Array.prototype.slice.call(
			root.querySelectorAll( '[data-collection-subnav-toggle]' )
		);

		if ( ! toggles.length ) {
			return;
		}

		function setToggleState( button, isOpen ) {
			var item = button.closest( '.collection-subnav__item' );
			var label = isOpen
				? button.getAttribute( 'data-close-label' )
				: button.getAttribute( 'data-open-label' );

			if ( item ) {
				item.classList.toggle( 'is-open', isOpen );
			}

			button.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );

			if ( label ) {
				button.setAttribute( 'aria-label', label );
			}
		}

		function closeSiblingDrawers( button ) {
			var item = button.closest( '.collection-subnav__item' );
			var parentList = item ? item.parentElement : null;

			if ( ! parentList ) {
				return;
			}

			Array.prototype.slice
				.call( parentList.children )
				.forEach( function ( sibling ) {
					var siblingToggle;

					if ( sibling === item ) {
						return;
					}

					siblingToggle = sibling.querySelector(
						':scope > [data-collection-subnav-toggle], :scope > .collection-subnav__toggle-wrap > [data-collection-subnav-toggle]'
					);

					if ( siblingToggle ) {
						setToggleState( siblingToggle, false );
					}
				} );
		}

		toggles.forEach( function ( button ) {
			setToggleState(
				button,
				button.getAttribute( 'aria-expanded' ) === 'true'
			);

			button.addEventListener( 'click', function () {
				var isOpen = button.getAttribute( 'aria-expanded' ) === 'true';

				closeSiblingDrawers( button );
				setToggleState( button, ! isOpen );
			} );

			button.addEventListener( 'keydown', function ( event ) {
				if ( event.key !== 'Escape' ) {
					return;
				}

				event.preventDefault();
				setToggleState( button, false );
				button.focus();
			} );
		} );
	}

	document.addEventListener( 'DOMContentLoaded', function () {
		Array.prototype.slice
			.call( document.querySelectorAll( '[data-collection-subnav]' ) )
			.forEach( initSubnav );
	} );
}() );
